<template>
  <div>
    <!-- 头部模板 -->
    <header-yjj-m></header-yjj-m>
    <div class="slide-img" ref="slide">
      <img id="slideImg" src="../../../assets/slide-1.jpg" ref="slideImg">
    </div>


    <div class="container" style="min-height: 580px;">

        <van-notice-bar left-icon="volume-o" style="margin-top: 5px;">
          <router-link :to="{name:'ArticleContentYjj',params:{id:'1680465689259765860',prevNav:'CulturalListYjj'}}" style="padding-left: 20px;">
            东北抗日义勇军纪念馆藏品征集政策与范围
          </router-link>
        </van-notice-bar>

      <div class="item" v-for="item in displayList" :key="item.index" style="margin-top: 10px;margin-bottom: 20px;" @click="bigImg(item.imgsrc)">

          <img :src="item.imgsrc" style="width: 100%">
          <p>{{ item.title }}</p>

      </div>

    </div>


    <van-overlay :show="show" class="bigimg">
      <h1 style="position: absolute;top:30px;right: 30px;color:white;" @click="closeBigImg()">
        <van-icon name="cross" />
      </h1>
      <div >
        <img :src="bigImgSrc" style="width: 100%;">
      </div>

    </van-overlay>

    <!-- 底部模板 -->
    <footer-yjj-m></footer-yjj-m>
  </div>
</template>

<script>
import HeaderYjjM from "@/components/yjj/mobile/HeaderYjjM";
import FooterYjjM from "@/components/yjj/mobile/FooterYjjM";
import {request} from "@/request/request";

export default {
  name: "CulturalListYjjM",
  components: {
    HeaderYjjM,
    FooterYjjM
  },
  data(){
    return{
      active: 0,
      activeFlag:'tongzhi',
      restfulUrl:'cultural',
      columnName:1,
      navList:[
        {name:'民族烽火',columnId:'tongzhi',},
        {name:'奋起抵抗',columnId:'dongtai',},
        {name:'浴血奋战',columnId:'dongtai',},
        {name:'不屈不挠',columnId:'dongtai',},
        {name:'时代强音',columnId:'dongtai',},
        {name:'英灵永驻',columnId:'dongtai',},
      ],
      displayList:[],
      bigImgSrc:'',
      isShowFlag:true,
      show:false,

    }
  },
  methods:{
    navCur(data){
      this.activeFlag = data;
      this.getListByColumn(data);
      if(data == 3){
        this.getOneByID("1680465689259765860");
        this.zhengji = true;
      }
      else{
        this.zhengji = false;
      }
    },
    getListByColumn(column){
      request({
        method:'POST',
        url:this.restfulUrl+'/getcolumn',
        data:{columnId:column}
      }).then(res =>{
        this.displayList = res.data;
      },err=>{
        console.log(err)
      })
    },
    getOneByID:function(uid){
      request({
        method:'GET',
        url:'articles/'+uid,
      }).then(res =>{
        this.articleData = []
        this.articleData.push(res.data)
      },err=>{
        console.log(err)
      })

    },
    bigImg(data){
      this.bigImgSrc = data;
      this.show = true;
    },
    closeBigImg(){
      this.show = false
    }
  },
  updated(){
    // if(this.$route.params.nav=='wenwu'){
    //   this.activeFlag = 3;
    //   this.zhengji = true;
    // }
  },
  mounted() {

    this.getListByColumn(1);

  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>
.container{
  padding:0 10px;
}
.slide-img{
  width:100%;
  overflow: hidden;
}
.slide-img img{
  width: 100%;
}
a{
  color: black;
}
.bigimg{
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
